<template>
  <page>
    <ZuiHeader/>
    <SubPageTemplate page-title="景区视频" :static-tab-list="tabList" :default-tab-id="defaultTabId" :page-size="6"
                     type="video" :ext1-empty="false" @article-click="itemClick" @tab-change="tabChange"></SubPageTemplate>
    <ZuiFooter/>
    <CmsVideoPlayer :src="videoSrc" :visible.sync="visible" :poster="poster"/>
    <CmsFramePlayer :src="liveSrc" :visible.sync="liveVisible"/>

  </page>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";
import CmsVideoPlayer from "~/components/cms/CmsVideoPlayer.vue";
import CmsFramePlayer from "~/components/cms/CmsFramePlayer.vue";

export default {
  components: {
    SubPageTemplate,
    CmsVideoPlayer,
    CmsFramePlayer
  },
  data() {
    return {
      tabList: [
        {id: '666', name: '精彩视频'},
        {id: '777', name: '景区直播'}
      ],
      videoSrc: '',
      visible: false,
      poster: '',
      liveSrc: '',
      liveVisible: false,
      tabIndex: 0,
      defaultTabId: '666'
    }
  },
  mounted() {
    this.defaultTabId = this.$route.query.id;
  },
  methods: {
    itemClick(data) {
      if (this.tabIndex === 0) {
        this.videoSrc = data.ext1;
        this.poster = data.cover;
        console.log(11)
        this.$nextTick(() => {
          this.visible = true;
        })
      } else {
        this.liveSrc = data.ext1;
        this.$nextTick(() => {
          this.liveVisible = true;
        });
      }
    },
    tabChange(index) {
      this.tabIndex = index;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/link/video.vue